import { PayMonth, PayRow } from '@fora-monorepo/employer-my-pages-common/types';

import { PayrollFormData } from '../types';

import { getAttributablePayToReport, hasInputPayDataChangedComparedToReported } from '.';

export const mapPayrollFormDataToPayRowList = (payrollFormData: PayrollFormData, payMonth?: PayMonth): PayRow[] => {
  const payRows: PayRow[] = [];
  Object.keys(payrollFormData).forEach(policyNumber => {
    const payrollFormDataEntry = payrollFormData[policyNumber];
    const payAmount = payrollFormDataEntry.payAmount;
    if (hasInputPayDataChangedComparedToReported(payrollFormDataEntry)) {
      payRows.push({
        policyNumber,
        employeeId: payrollFormDataEntry.employeeId,
        firstName: payrollFormDataEntry.firstName,
        lastName: payrollFormDataEntry.lastName,
        payMonth: payMonth ?? '',
        payAmount: payAmount ?? 0,
        attributablePay: getAttributablePayToReport(payrollFormDataEntry),
      });
    }
  });
  return payRows;
};
